class ProductCard extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()

    this.featuredImageContainer = this.querySelector('[data-el="product-card.featured-image"]')
    this.darkImageContainer = this.querySelector('[data-el="product-card.dark-image"]')
    this.sideImageContainer = this.querySelector('[data-el="product-card.side-image"]')
    this.productCardUrl = this.querySelector('[data-el="product-card.url"]')
  }

  setupListeners () {
    this.swatches = this.querySelectorAll('[data-el="product-card.swatch"]')
    if (this.swatches.length === 0) return

    this.handleSwatchSelect = this.handleSwatchSelect.bind(this)
    this.swatches.forEach(swatch => {
      swatch.addEventListener('focus', this.handleSwatchSelect.bind(this))
      swatch.addEventListener('mouseover', this.handleSwatchSelect.bind(this))
    })
  }

  handleSwatchSelect (event) {
    const swatch = event.target

    if (swatch.checked) return

    swatch.checked = true

    const imagesData = [
      {
        key: "featured",
        src: swatch.dataset.featuredImageUrl,
        alt: swatch.dataset.value,
        container: this.featuredImageContainer,
      },
      {
        key: "dark",
        src: swatch.dataset.darkImageUrl,
        alt: swatch.dataset.value,
        container: this.darkImageContainer,
      },
      {
        key: "side",
        src: swatch.dataset.sideImageUrl,
        alt: swatch.dataset.value,
        container: this.sideImageContainer,
      },
    ]

    this.updateImages(imagesData)
    this.updateCardUrl(swatch.dataset.url)
  }

  updateImages(imagesData) {
    imagesData.forEach(data => {
      const { key, src, alt, container } = data

      if (src) {
        this.setAttribute(`data-${key}-image`, true)

        // Build image markup with image source, type, and alt
        let imageMarkup = this.imageMarkup
        imageMarkup = imageMarkup.replaceAll('[src]', src).replaceAll('[type]', key).replaceAll('[alt]', alt)

        // Add image to container
        container.innerHTML = imageMarkup

      } else {
        this.setAttribute(`data-${key}-image`, false)
        container.innerHTML = ''
      }
    })
  }

  updateCardUrl (url) {
    if (url) this.productCardUrl.href = url
  }

  get imageMarkup () {
    return `
      <img
        src="[src]"
        alt="[alt]"
        width="375"
        height="500"
        loading="eager"
        class="prd-ProductCard_ImageEl prd-ProductCard_ImageEl-[type]"
      >
    `
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard)
}